module.exports = __webpack_public_path__ + "img/kyouzai_asobi.209744d6.png";